<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
<!--            <el-form-item class="query-form-item" label="查询时间:">-->
<!--                <el-date-picker v-model="query.startTime" type="datetime" placeholder="选择开始日期" >-->
<!--                </el-date-picker>-->
<!--                <span> - </span>-->
<!--                <el-date-picker v-model="query.endTime" type="datetime" placeholder="选择结束日期" >-->
<!--                </el-date-picker>-->
<!--            </el-form-item>-->
            <el-form-item>
                <el-date-picker v-model="servetime" type="datetimerange" :picker-options="pickerOptions"
                                range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" align="left"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                :default-time="['00:00:00', '23:59:59']" @change="dateChange"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table ref="multipleTable" v-loading="loading" :data="list"
                  :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
                  border>
            <!-- <el-table-column type="selection" width="50" fixed /> -->
            <el-table-column label="ID" prop="id" width="80" align="center" />
            <el-table-column label="邮箱地址" prop="mail" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="姓名" prop="name" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="公司名称" prop="company" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="国家"  prop="country" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="电话号码" prop="phone" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="提交时间" width="300" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span>{{scope.row.createTime | formatDateStr("yyyy-MM-dd hh:mm:ss") }}</span>
                </template>
            </el-table-column>
            <el-table-column label="处理时间" width="300" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span v-if="scope.row.handleTime!=null">{{scope.row.handleTime | formatDateStr("yyyy-MM-dd hh:mm:ss")}}</span>
                    <span v-if="scope.row.handleTime==null">暂无</span>
                </template>
            </el-table-column>
            <el-table-column label="处理人" prop="authadminName" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="操作" align="center" width="180">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" plain @click.native="viewDetails(scope.row.id)">查看</el-button>
                    <el-button v-if="scope.row.state == 1" type="primary" plain disabled>已处理</el-button>
                    <el-button v-if="scope.row.state == 2" type="warning" plain @click.native="handle(scope.row.id)">处理</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination-container" background :current-page="query.currentPage"
                       :page-size="query.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>
    </div>
</template>

<script>
import {
    getListApi,
    handleApi,
    // authAdminSave,
    // authAdminDelete
} from "@/api/generalinquiry/generalinquiry";
import {getAdminId} from "@/utils/auth";
const formJson = {
    id: "",
    password: "",
    username: "",
    compellation: "",
    roleId: "",
    tel: "",
    email: "",
    avatar: "",
    status: 1,
    roles: []
};
export default {
    data() {
        return {
            query: {
                currentPage: 1,
                startTime: "",
                endTime: "",
                pageSize: 10,
            },
            roles: [],
            list: [],
            form: {
                id: '',
                adminId: ''
            },
            totalNumber: 0,
            loading: true,
            index: null,
            formName: null,
            cancelToggle: false,
            formLoading: false,
            formVisible: false,
            formInput: false,
            formData: formJson,
            formAdd: formJson,
            formRules: {},
            servetime: [],
            multipleSelection: [] //多选集合
        };
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (val == "") {
                this.cancelToggle = false;
                return;
            }
            this.cancelToggle = true;
        },
        onRest() {
            this.query = {
                currentPage: 1,
                startTime: "",
                endTime: "",
                pageSize: 10,
            };
            this.servetime = [];
            this.getList();
        },
        onSubmit() {
            this.query.currentPage = 1;
            this.$router.push({
                path: ""
                //query: this.query
            });
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            //scrollTo(0, 800);
            this.getList();
        },
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getList();
        },
        dateChange(val) {
            if (val == null) {
                this.query.startTime = "";
                this.query.endTime = "";
            } else {
                this.query.startTime = val[0];
                this.query.endTime = val[1];
            }
            this.getList();
        },
        getList() {
            this.loading = true;
            getListApi(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.list = response.data.list || [];

                    this.totalNumber = response.data.totalNumber || 0;
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.totalNumber = 0;
                    this.roles = [];
                });
        },
        // getRoleList() {
        //     authAdminRoleList(this.query)
        //         .then(response => {
        //             if (response.code) {
        //                 this.$message.error(response.message);
        //                 return false;
        //             }
        //             this.roles = response.data.list || [];
        //         })
        //         .catch(() => {});
        // },
        viewDetails(id) {
            //带参数跳转
            console.log("/generalinquiry/details= " ,id);
            this.$router.push({
                path: "/generalinquiry/details",
                query: {
                    id: id
                }
            });
        },
        // 处理
        handle(id) {
            let adminId= getAdminId();
            if (id) {
                this.$confirm("确认要处理吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let para = {
                            id: id,
                            adminId: adminId
                        };
                        handleApi(para)
                            .then(response => {
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("处理成功！");
                                this.getList();
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            }
        }
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success",
                2: "danger"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "禁用",
                1: "正常",
                2: "未验证"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.pageSize = parseInt(this.query.pageSize);
        // 加载表格数据
        this.getList();
        // 加载角色列表
        // this.getRoleList();
    }
};

</script>

<style>
body {
    margin: 0;
}

</style>
